module.exports = __webpack_public_path__ + "img/visit-inpatient.e754d101.svg";